export function WorldPointToPixelPoint(point, zoom) {
  return { x: point.x * Math.pow(2, zoom), y: point.y * Math.pow(2, zoom) };
}
